import React, { useEffect, useState, useMemo } from 'react';
import { getdata, updatedata, formatdate } from "../../util/global";
import PrescriptionAdminTable from './PrescriptionAdminTable';
import PrescriptionForm from './PrescriptionForm';
import PrescriptionView from './PrescriptionView';


const PrescriptionAdmin = () => {
  const [prescriptiondata, setprescriptiondata] = useState([]);
  const [patientdata, setpatientdata] = useState([]);
  
  const [searchquery, setsearchquery] = useState("");
  const [mode, setmode] = useState(false);

  const [formdata, setformdata] = useState({ name: "", phonenumber: "",
    datetime: formatdate(new Date()),
    medicinedata: [{ medicine: "", dosage: "", instructions: "" }],
    notes: "", _id: null });


  const fetchdata = async () => {
    try {
      const pdata = await getdata({ filter: { datatype: "prescriptiondata" } });
      setprescriptiondata( pdata.reverse());
      const patdata = await getdata({ filter: { datatype: "patientdata" } });
      setpatientdata(patdata);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { 
    fetchdata(); 
  }, []);

  const filteredprescriptions = useMemo(() => {
    return prescriptiondata.filter(p => 
      p.name?.toLowerCase().includes(searchquery.toLowerCase()) || 
      p.medicine?.toLowerCase().includes(searchquery.toLowerCase())
    );
  }, [prescriptiondata, searchquery]);

  //const contactmap = useMemo(() => new Map(patientdata.map(p => [p.name, p.phonenumber])), [patientdata]);

  const openedit = (type, item) => {
    setformdata({ ...item, _id: item._id });
    setmode("edit" + type );
  };

  const openview = (type, item) => {
    setformdata({ ...item, _id: item._id });
    setmode("view" + type );
  };

  const handlesubmit = async () => {
    let patient = patientdata.find(item => item.phonenumber == formdata.phonenumber);
    let patientpayload = {data: {name:formdata.name, phonenumber:formdata.phonenumber, datatype:"patientdata", appname:window.APPSETTING.appname}};
    let patientuserid = 0;
    if (patient) {
      patientpayload.data._id = patient._id;
      patientpayload.data._userid = patient._userid;
      patientuserid = patient._userid;
    }

    console.log("patientpayload ", patientpayload);
    let patientid = await updatedata(patientpayload);
    formdata._patientid = patientid[0].id;

    const payload = { data: { ...formdata, datatype: "prescriptiondata" } };
    if (patientuserid) {
      payload.data.access = [{_userid:patientuserid, accesstype:"read" }];
      //payload.data._userid = patientuserid;
    }

    let prescriptionid = await updatedata(payload);
    formdata._id = prescriptionid[0].id;
    await fetchdata();
    
    openview("prescription", formdata);
  };

  return (
    <div className="content-area">
      <div className="table-header-row">
        <div>
          <h1 className="dash-title" style={{ marginBottom: 4 }}>Prescriptions</h1>
          <p className="muted-sm">Manage all patient prescriptions</p>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <input 
            type="text" 
            placeholder="search name or medicine..." 
            className="form-input" 
            style={{ width: '250px' }}
            value={searchquery}
            onChange={(e) => setsearchquery(e.target.value)}
          />
          <button className="btn-blue" onClick={() => {
            setformdata({ name: "", phonenumber: "", medicine: "", dosage: "", instructions: "", notes: "", _id: null, datetime: formatdate(new Date()) });
            setmode("editprescription");
          }}>+ New Prescription</button>
        </div>
      </div>

      <PrescriptionAdminTable data={filteredprescriptions} openedit={openedit} openview={openview} />
      
      <PrescriptionForm 
        mode={mode} 
        setmode={setmode} 
        formdata={formdata} 
        setformdata={setformdata}
        handlesubmit={handlesubmit}
        patientdata={patientdata}
        prescriptiondata={prescriptiondata}

      />

      <PrescriptionView 
        mode={mode} 
        setmode={setmode} 
        formdata={formdata} 
        patientdata={patientdata}
        prescriptiondata={prescriptiondata}
      />
      

    </div>
  );
};

export default PrescriptionAdmin;